import { PlusOutlined } from "@ant-design/icons"
import { Card, Flex, Typography, Upload, type UploadProps } from "antd"
import React, { memo, useMemo } from "react"
import { useTranslation } from "react-i18next"

import { ATTACHMENT_MAX_SIZE_MB } from "../../../../../../utils/attachment-upload.ts"

interface ProjectViewAlbumAttachmentsUploadProps {
  onBeforeUpload?: (file: File) => boolean
}

export const ProjectViewAlbumAttachmentsUpload = memo(
  function ProjectViewAlbumAttachmentsUpload({
    onBeforeUpload
  }: ProjectViewAlbumAttachmentsUploadProps) {
    const { t } = useTranslation()

    const uploadProps: UploadProps = useMemo(
      () => ({
        showUploadList: false,
        multiple: true,
        beforeUpload: onBeforeUpload as UploadProps["beforeUpload"]
      }),
      [onBeforeUpload]
    )

    return (
      <Upload {...uploadProps} rootClassName="h-full [&_.ant-upload]:size-full">
        <Card
          hoverable
          className="h-full min-h-[120px] flex items-center justify-center"
        >
          <Flex vertical align="center" gap={8}>
            <PlusOutlined className="text-2xl" />
            <Typography.Text type="secondary" className="text-xs text-center">
              {t("files.upload.maxSize", { size: ATTACHMENT_MAX_SIZE_MB })}
            </Typography.Text>
          </Flex>
        </Card>
      </Upload>
    )
  }
)
